import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import mesoRegionReadAction from './mesoRegionRead.action.json' assert { type: 'json' }

const mesoRegionReadDefinition = defineReadAutoAction(mesoRegionReadAction, 'mesoRegion')

export default mesoRegionReadDefinition
